import { ThemeProvider } from "@mui/material/styles";
import { ErrorBoundary } from "@sentry/react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import theme from "styles/theme";

import { ScopedCssBaseline } from "components/core";

import { UserError } from "../errors";

import ErrorDialog from "./error-dialog";
import ErrorPage from "./error-page";

const Wrapper = ({ children }) => {
  const [error, setError] = useState();

  useEffect(() => {
    const handleError = (event) => {
      if (event.error instanceof UserError) {
        setError(event.error);
      }
    };

    const handleRejection = (rejection) => {
      if (rejection.reason instanceof UserError) {
        setError(rejection.reason);
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  const handleDialogClose = () => {
    setError(null);
  };

  const beforeCapture = (scope) => {
    scope.setTag("react", "yes");
    scope.setTag("rendered", "no");
  };

  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <ErrorBoundary beforeCapture={beforeCapture} fallback={ErrorPage}>
          <ErrorDialog open={!!error} onClose={handleDialogClose} />
          {children}
        </ErrorBoundary>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
};

Wrapper.propTypes = { children: PropTypes.element.isRequired };

export default Wrapper;
